/**
 * AgriNexus mascot — "Giulio il Contadino"
 * 3D Pixar-style renders (Gemini Nano Banana) animati con CSS.
 *
 * Pose disponibili: 'wave' | 'search' | 'welcome' | 'analyze' | 'lost'
 *
 * Animazioni:
 *  - float: galleggia su-giù dolcemente (3s)
 *  - breath: scala impercettibile (4s)
 *  - interactive: cursor pointer + hover scale (quando onClick)
 */
import './Mascot.css';

const POSE_SRC = {
  wave: '/mascot/giulio-wave.png',
  search: '/mascot/giulio-search.png',
  welcome: '/mascot/giulio-welcome.png',
  analyze: '/mascot/giulio-analyze.png',
  lost: '/mascot/giulio-lost.png',
  basket: '/mascot/giulio-basket.png',
  point: '/mascot/giulio-point.png',
  celebrate: '/mascot/giulio-celebrate.png',
};

export default function Mascot({
  pose = 'wave',
  size = 200,
  animated = true,
  spinning = false,          // rotazione lenta — per loading states
  interactive = false,       // hover effect
  shadow = true,
  className = '',
  onClick,
  'data-testid': testId,
}) {
  const src = POSE_SRC[pose] || POSE_SRC.wave;
  const classes = [
    'mascot',
    animated && 'mascot--animated',
    spinning && 'mascot--spinning',
    interactive && 'mascot--interactive',
    shadow && 'mascot--shadow',
    className,
  ].filter(Boolean).join(' ');

  return (
    <div
      className={classes}
      onClick={onClick}
      data-testid={testId || `mascot-${pose}`}
      style={{ width: size, height: size }}
    >
      <img
        src={src}
        alt=""
        aria-hidden="true"
        className="mascot__img"
        draggable={false}
        loading="lazy"
      />
    </div>
  );
}
